import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import McpHero from "@/components/mcp/McpHero";
import McpPainSection from "@/components/mcp/McpPainSection";
import McpHowItWorks from "@/components/mcp/McpHowItWorks";
import McpBudgetTiers from "@/components/mcp/McpBudgetTiers";
import McpCapabilities from "@/components/mcp/McpCapabilities";
import McpComparisonTable from "@/components/mcp/McpComparisonTable";
import McpSafetySection from "@/components/mcp/McpSafetySection";
import McpPricingCard from "@/components/mcp/McpPricingCard";
import McpFaq from "@/components/mcp/McpFaq";
import McpFinalCta from "@/components/mcp/McpFinalCta";
import { trackEvent } from "@/utils/tagManagerUtils";

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Upfixe — The first chat-native Google Ads platform",
  description:
    "Build, edit and publish Google Ads campaigns by chatting with Claude, ChatGPT or Perplexity. $99/month, 7-day free trial.",
  brand: { "@type": "Brand", name: "Upfixe" },
  category: "SoftwareApplication",
  offers: {
    "@type": "Offer",
    price: "99",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
    url: "https://upfixe.com/mcp",
  },
};

const McpLanding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent("mcp_page_view", { path: "/mcp" });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Upfixe — The first chat-native Google Ads platform</title>
        <meta
          name="description"
          content="Build, edit and publish Google Ads campaigns by chatting with Claude, ChatGPT or Perplexity. Skip the agency. $99/month, 7-day free trial."
        />
        <meta
          name="keywords"
          content="chat-native google ads, google ads mcp, google ads chatgpt, google ads claude, manage google ads with ai, mcp server google ads, perplexity google ads, ppc agency alternative"
        />
        <meta
          property="og:title"
          content="Upfixe — The first chat-native Google Ads platform"
        />
        <meta
          property="og:description"
          content="Every other Google Ads connector is read-only. Upfixe writes. Build and publish campaigns by chat in four minutes."
        />
        <meta property="og:image" content="https://upfixe.com/og-mcp.png" />
        <meta property="og:url" content="https://upfixe.com/mcp" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://upfixe.com/mcp" />
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>

      <Header />

      <main className="flex-grow">
        <McpHero />
        <McpPainSection />
        <McpHowItWorks />
        <McpBudgetTiers />
        <McpCapabilities />
        <McpComparisonTable />
        <McpSafetySection />
        <McpPricingCard />
        <McpFaq />
        <McpFinalCta />
      </main>

      <Footer />
    </div>
  );
};

export default McpLanding;
